import { render } from "./AddEditPubs.vue?vue&type=template&id=4d9e76cf"
import script from "./AddEditPubs.vue?vue&type=script&lang=js"
export * from "./AddEditPubs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__